export default "__VITE_ASSET__PZltVitj__"